import styled from "styled-components";
import { DefaultButton, Dropdown } from "@fluentui/react";

export const HeaderContainer = styled.div`
    margin-bottom: 2rem;
    padding: 0;
    width: 100%;

    h2
    {
        margin-bottom: 0;
        font-size: 2rem;
        cursor: default;
        
        @media(min-width: 992px)
        {
            font-size: 2.15rem;
        }
    }
`;
export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.75rem;
    flex-wrap: nowrap;
    margin-bottom: 1rem;
    background-color: ${props => props?.theme?.palette?.white || '#fff'};
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    padding: 0.75rem 1rem;
    min-height: 50px;

    > * {
        flex-shrink: 0;
    }

    @media(max-width: 1200px)
    {
        flex-wrap: wrap;
        gap: 0.75rem;
        padding: 0.75rem;
    }

    @media(max-width: 768px) 
    {
        flex-direction: column;
        align-items: stretch;
        gap: 0.5rem;
        padding: 0.5rem;
        
        > * {
            flex-shrink: 1;
        }
    }
`;
export const Label = styled.label`
    color: #CC214F;
    font-weight: 500;
    font-size: 1.1rem !important;
    white-space: nowrap;
    height: 36px;
    display: flex;
    align-items: center;
    min-width: fit-content;
    
    @media(max-width: 768px)
    {
        font-size: 1rem !important;
    }
`;
export const StyledDropdown = styled(Dropdown)`
    min-width: 180px;
    flex: 1;
    height: 36px !important;

    .ms-Dropdown
    {
        height: 36px !important;
    }
    
    .ms-Dropdown-title
    {
        height: 36px !important;
        padding: 0 12px;
        display: flex;
        align-items: center;
    }
    
    .ms-Callout
    {
        position: absolute !important;
        top: 100% !important;
        left: 0 !important;
        right: auto !important;
        transform: none !important;
    }
    
    @media(max-width: 1200px)
    {
        min-width: 200px;
        flex: none;
        width: 100%;
    }
    
    @media(max-width: 768px)
    {
        min-width: 100%;
        margin: 0;
    }

    && .ms-Checkbox.ms-Dropdown-item.dropdown-133 label.ms-Checkbox-label.label-135,
    && .ms-Checkbox label,
    && .ms-Checkbox .ms-Checkbox-label,
    && .ms-Checkbox.is-enabled label,
    && .ms-Checkbox.is-enabled .ms-Checkbox-label
    {
        color: ${props => props?.theme?.palette?.neutralPrimary || '#000000'} !important;
    }

    .ms-Dropdown-title
    {
        border-color: #CC214F !important;
    }

    .ms-Dropdown-caretDownWrapper
    {
        color: #CC214F !important;
    }

    .ms-Checkbox-checkbox
    {
        border-color: #CC214F !important;
        
        &.is-checked
        {
            background-color: #CC214F !important;
        }
    }

    &:hover .ms-Dropdown-title
    {
        border-color: #CC214F !important;
    }

    &:focus .ms-Dropdown-title
    {
        border-color: #CC214F !important;
    }

    .ms-Dropdown-multiSelectItem
    {
        background-color: #CC214F !important;
        color: white !important;
    }

    &.is-disabled,
    &[disabled]
    {
        .ms-Dropdown-title
        {
            background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'} !important;
            border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
            cursor: not-allowed !important;
        }

        .ms-Dropdown-caretDownWrapper
        {
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        }

        &:hover .ms-Dropdown-title
        {
            border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        }
    }
`;
export const ActionButton = styled(DefaultButton)`
    background-color: #CC214F !important;
    color: white !important;
    border: none;
    min-width: 120px;
    height: 36px;
    font-size: 13px;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover
    {
        background-color: #A41B40 !important;
    }

    &:disabled,
    &.is-disabled
    {
        background-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        color: ${props => props?.theme?.palette?.neutralTertiaryAlt || '#c8c6c4'} !important;
        cursor: not-allowed !important;
        
        &:hover
        {
            background-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        }
    }
`;
export const CardsContainer = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 1rem;
    margin: 1rem 0;
    flex-wrap: wrap;
    width: 100%;
    cursor: default;
`;
export const Card = styled.div`
    background-color: ${props => props?.theme?.palette?.tertiary || "#e9eff1"};
    color: ${props => props?.theme?.palette?.neutralPrimary || '#000000'};
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    padding: 0.9rem;
    min-width: 150px;
    cursor: inherit;

    &.portfolio-card
    {
        flex: 1;
        max-width: calc(100% - 800px);
        min-width: 200px;
    }

    &.metric-card
    {
        width: 180px;

        @media(max-width: 992px)
        {
            width: calc(50% - 0.5rem);
        }
        
        @media(max-width: 576px)
        {
            width: 100%;
        }
    }
`;
export const CardTitle = styled.div`
    color: ${props => props?.theme?.palette?.primary};
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    margin-bottom: 0.5rem;
    cursor: inherit;
`;
export const CardData = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 1.25rem;
    font-weight: 500;
    cursor: inherit;
`;
export const MetricCardData = styled(CardData)`
    justify-content: flex-end;
`;
export const MetricsContainer = styled.div`
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    
    @media(max-width: 992px)
    {
        width: 100%;
        justify-content: flex-end;
    }
`;
export const GraphicsContainer = styled.div`
    background-color: ${props => props?.theme?.palette?.white || '#fff'};
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    padding: 1.5rem;
    margin-top: 1rem;
    width: 100%;
    max-width: calc(100vw - 8rem);
    min-height: 400px;
    margin-left: auto;
    margin-right: auto;
`;
export const GraphicTitle = styled.h3`
    margin: 0 0 1.5rem 0;
    font-size: 1.25rem;
    cursor: default;
    color: ${props => props?.theme?.palette?.neutralPrimary || '#000000'};
`;
export const TableWrapper = styled.div`
    background: ${props => props?.theme?.palette?.white};
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    padding: 1.5rem;
    margin-top: 1rem;
    width: 100%;
    max-width: calc(100vw - 8rem);
    cursor: default;

    *
    {
        cursor: default;
    }

    input, 
    button, 
    a
    {
        cursor: pointer;
    }
`;
export const Table = styled.table<{$hasMultiplePortfolios?: boolean}>`
    width: 100%;
    border-collapse: collapse;
    
    thead tr
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter};
        ${props => props.$hasMultiplePortfolios && `border-bottom: 2px solid white;`}
    }
    
    th, td
    {
        padding: 1rem;
        text-align: left;
    }
    
    th
    {
        font-weight: 600;
        font-size: 14px;
    }
    
    td
    {
        font-size: 14px;
    }
    
    th:last-child,
    td:last-child
    {
        text-align: right;
    }
`;
export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 1rem;
    
    h3
    {
        font-size: 16px;
        font-weight: 600;
        margin: 0;
        
        span
        {
            color: ${props => props?.theme?.palette?.neutralSecondary};
            font-weight: normal;
            margin-left: 0.5rem;
        }
    }
`;
export const CounterContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    h3
    {
        margin: 0;
        font-size: 1.25rem;
    }
`;

export const CounterLabel = styled.div`
    background-color: #CC214F;
    color: white;
    border: none;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-weight: 600;
    width: 36px;
    height: 36px;
    box-sizing: border-box;
    cursor: default;
`;

export const DateNavigator = styled.div`
    display: flex;
    align-items: center;
    border: 1px solid #CC214F;
    border-radius: 5px;
    background-color: ${props => props?.theme?.palette?.white || '#fff'};
    height: 36px;
    width: 150px;
    box-sizing: border-box;
    
    @media(max-width: 1200px)
    {
        width: 130px;
    }

    @media(max-width: 768px)
    {
        width: 100%;
    }
`;

export const NavigationArrow = styled.button`
    background-color: transparent;
    border: none;
    color: #CC214F;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    font-size: 16px;
    font-weight: bold;
    padding: 0;
    
    &:hover
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f8f9fa'};
        color: #A41B40;
    }

    &:disabled
    {
        color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        cursor: not-allowed;
        
        &:hover
        {
            background-color: transparent;
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        }
    }
`;

export const DateLabel = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: ${props => props?.theme?.palette?.neutralPrimary || '#323130'};
    padding: 0 8px;
    text-align: center;
    cursor: default;
    user-select: none;
`;

export const SmallButton = styled.button`
    background-color: transparent;
    border: 2px solid #CC214F;
    color: #CC214F;
    border-radius: 5px;
    padding: 0 12px;
    font-size: 12px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 36px;
    height: 36px;
    box-sizing: border-box;
    
    &:hover
    {
        background-color: #CC214F;
        color: white;
    }

    &:disabled
    {
        border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        cursor: not-allowed;
        
        &:hover
        {
            background-color: transparent;
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        }
    }

    svg
    {
        width: 14px;
        height: 14px;
    }
`;

export const EditButton = styled.button`
    background-color: ${props => props?.theme?.palette?.white || '#fff'};
    border: 1px solid #CC214F;
    color: #CC214F;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    box-sizing: border-box;
    
    &:hover
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f8f9fa'};
        border-color: #A41B40;
        color: #A41B40;
    }

    &:disabled
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'};
        border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        cursor: not-allowed;
        
        &:hover
        {
            background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'};
            border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        }
    }

    .ms-Icon
    {
        font-size: 14px;
    }
`;

export const DeleteButton = styled.button`
    background-color: ${props => props?.theme?.palette?.white || '#fff'};
    border: 1px solid #CC214F;
    color: #CC214F;
    border-radius: 50%;
    padding: 0;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    box-sizing: border-box;
    
    &:hover
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f8f9fa'};
        border-color: #A41B40;
        color: #A41B40;
    }

    &:disabled
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'};
        border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        cursor: not-allowed;
        
        &:hover
        {
            background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'};
            border-color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        }
    }

    .ms-Icon
    {
        font-size: 14px;
    }
`;

export const MainButton = styled(ActionButton)`
    min-width: 140px;
    padding: 0 16px;
    font-size: 12px;
    height: 36px;
    
    @media(max-width: 768px)
    {
        min-width: 120px;
    }
`;

export const ExportIcon = styled.div`
    color: #CC214F;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    
    &:hover
    {
        color: #A41B40 !important;
    }

    &.disabled
    {
        background-color: inherit !important;
        color: #A41B40 !important;
        cursor: not-allowed;
        
        &:hover
        {
            color: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'} !important;
        }
    }

    svg
    {
        width: 20px;
        height: 20px;
    }
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 200px;
    flex-direction: column;
    gap: 1rem;
    background-color: ${props => props?.theme?.palette?.white || '#fff'};
    border-radius: 10px;
    box-shadow: rgb(0 0 0 / 13%) 0px 1.6px 3.6px 0px, rgb(0 0 0 / 11%) 0px 0.3px 0.9px 0px;
    margin-top: 1rem;
    padding: 2rem;
`;

export const LoadingMessage = styled.div`
    color: ${props => props?.theme?.palette?.neutralPrimary || '#000000'};
    font-size: 14px;
    font-weight: 500;
    text-align: center;
`;

export const LoadingGraphicContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 300px;
    gap: 1rem;
`;

export const SpanLoadingGraphic = styled.span`
    font-size: 18px;
    font-weight: bold;
    cursor: default;
`;

export const SpanSubtitleLoadingGraphic = styled.span`
    font-size: 14px;
    cursor: default;
`;

// Estilos para la tabla de ratios
export const RatioTableContainer = styled.div`
    padding: 0 1rem 0 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    box-sizing: border-box;
    overflow: hidden;
    min-height: 0;
    cursor: default;

    *
    {
        cursor: default;
    }

    input, 
    button, 
    a
    {
        cursor: pointer;
    }

    @media(max-width: 1200px)
    {
        margin-bottom: 1rem;
        min-height: auto;
    }
`;

export const RatioTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    
    thead tr
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'} !important;
    }
    
    thead th
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter || '#f3f2f1'} !important;
        padding: 1rem;
        text-align: left;
        font-weight: 600;
        font-size: 14px;
    }
    
    thead th:last-child
    {
        text-align: right;
    }
    
    tbody td
    {
        padding: 1rem;
        text-align: left;
        font-size: 14px;
    }
    
    tbody td:last-child
    {
        text-align: right;
    }
`;

export const RatioTableScrollContainer = styled.div`
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    
    &::-webkit-scrollbar
    {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track
    {
        background: ${props => props?.theme?.palette?.neutralLighterAlt || '#faf9f8'};
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb
    {
        background: ${props => props?.theme?.palette?.neutralTertiary || '#a19f9d'};
        border-radius: 3px;
        
        &:hover
        {
            background: ${props => props?.theme?.palette?.neutralSecondary || '#605e5c'};
        }
    }
`;

// Componentes específicos para la tabla de ratios con estilos explícitos
export const RatioTableHeader = styled.thead`
    tr
    {
        background-color: ${props => props?.theme?.palette?.neutralLighter};
    }
`;

export const RatioTableHeaderCell = styled.th`
    padding: 1rem;
    text-align: left;
    font-weight: 600;
    font-size: 14px;
    
    &:last-child
    {
        text-align: right;
    }
`;

export const RatioTableRow = styled.tr``;
export const RatioTableCell = styled.td`
    padding: 1rem;
    text-align: left;
    font-size: 14px;
    
    &:last-child
    {
        text-align: right;
    }
`;

export const GraphicsContentContainer = styled.div`
    display: flex;
    width: 100%;
    gap: 1rem;
    align-items: stretch;

    @media(max-width: 1200px)
    {
        flex-direction: column;
        gap: 0.75rem;
    }
`;

export const RatiosSectionContainer = styled.div`
    flex: 0 0 25%;
    max-width: 25%;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    @media(max-width: 1200px)
    {
        flex: 1 1 100%;
        max-width: 100%;
    }
`;

export const ChartSectionContainer = styled.div`
    flex: 0 0 75%;
    max-width: 75%;
    display: flex;
    flex-direction: column;

    @media(max-width: 1200px)
    {
        flex: 1 1 100%;
        max-width: 100%;
    }
`;